import React from 'react'
import {connect} from 'react-redux'
import propTypes from 'prop-types'
import Moment from 'react-moment'
import defaultSettings from 'config/defaultSettings'
import {getRegionalDateFormat, getRegionalLocale, getRegionalTimeFormat} from 'selectors/settings'

const DateTime = (props) => {
  const {
    locale = defaultSettings.locale,
    timeFormat = defaultSettings.timeFormat,
    dateFormat = defaultSettings.dateFormat,
    children,
    ...otherProps
  } = props

  return (
      <Moment
          locale={locale}
          format={`${dateFormat} ${timeFormat}`}
          {...otherProps}
      >
        {children}
      </Moment>
  )
}

DateTime.propTypes = {
  locale: propTypes.string,
  dateFormat: propTypes.string,
  timeFormat: propTypes.string,
  children: propTypes.oneOfType([
    propTypes.string,
    propTypes.instanceOf(Date),
    propTypes.object,
    propTypes.number,
    propTypes.array,
  ]),
  date: propTypes.oneOfType([
    propTypes.string,
    propTypes.instanceOf(Date),
    propTypes.object,
    propTypes.number,
    propTypes.array,
  ]),
}

const mapStateToProps = (state) => ({
  locale: getRegionalLocale(state),
  dateFormat: getRegionalDateFormat(state),
  timeFormat: getRegionalTimeFormat(state),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DateTime)
